import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/browser";
import config from "config/config";
import { UnhandledError } from "./UnhandledError";
import { ReactNode } from "react";

Sentry.init({
  dsn: config.sentryDsn,
  integrations: [new BrowserTracing(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  release: "0.0.1",
  environment: config.environment,
  autoSessionTracking: true,
  attachStacktrace: true,
  enabled: config.environment === "production"
});

export const ErrorBoundary = ({ children }: { children: ReactNode }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => <UnhandledError errorMessage={error.message} />}
      showDialog
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
